module.exports = __webpack_public_path__ + "img/cancelar.632b29f7.png";